import React, { useEffect, useState } from 'react';

export default function ListPager({
  changeLimit,
  nextPage,
  prevPage,
  setPagerIndex,
  totalEvents,
  pagerIndex,
  limit,
  totalPages,
  paginatedItemCount
}) {
  const [isEnd, setEnd] = useState(false);
  const [hide, setHide] = useState(false);

  useEffect(() => {
    if (pagerIndex === totalPages - 1) setEnd(true);
  }, [pagerIndex]);

  useEffect(() => {
    paginatedItemCount < limit ? setHide(true) : setHide(false);
  }, [paginatedItemCount]);

  return (
    <section className="section u--margin-bottom-50">
      <div className="pagination__section">
        <div className="grid grid--std">
          <div className="grid__col-xs-12">
            <div className="pagination__container">
              <nav>
                <ul className="pagination pagination--md">
                  <li
                    className={`pagination__item ${
                      pagerIndex === 0 ? 'pagination__item--disabled' : ''
                    }`}
                  >
                    <button
                      onClick={() => prevPage()}
                      disabled={pagerIndex === 0}
                    >
                      <i className="icon-arrow2-left-blue"></i>Prev
                    </button>
                  </li>
                  {pagerIndex >= 1 && (
                    <li
                      onClick={() => setPagerIndex(0)}
                      className="pagination__item"
                    >
                      <button>1</button>
                    </li>
                  )}
                  {pagerIndex > 1 && (
                    <li className="pagination__item">
                      <button onClick={() => setPagerIndex(pagerIndex - 1)}>
                        {pagerIndex}
                      </button>
                    </li>
                  )}

                  <li className="pagination__item pagination__item--active">
                    <button>{pagerIndex + 1}</button>
                  </li>
                  {pagerIndex !== totalPages - 2 && (
                    <li
                      className={`pagination__item ${
                        isEnd || hide ? 'u--hidden' : ''
                      }`}
                    >
                      <button onClick={() => setPagerIndex(pagerIndex + 1)}>
                        {pagerIndex + 2}
                      </button>
                    </li>
                  )}

                  {pagerIndex + 1 !== totalPages && (
                    <li className="pagination__item">
                      <button onClick={() => setPagerIndex(totalPages - 1)}>
                        {totalPages}
                      </button>
                    </li>
                  )}

                  {pagerIndex !== totalPages - 1 && (
                    <li className="pagination__item">
                      <button onClick={() => nextPage()}>
                        Next<i className="icon-arrow-right-blue"></i>
                      </button>
                    </li>
                  )}
                </ul>
              </nav>

              <div className="pagination__results-per-page">
                <div className="pagination__results-label">
                  Results per page:
                </div>
                <div className="pagination__results-input-wrapper">
                  <select
                    onChange={(event) =>
                      changeLimit(parseInt(event.target.value))
                    }
                    className="pagination__results-input"
                  >
                    <option value="12">12</option>
                    <option value="24">24</option>
                    <option value="48">48</option>
                    <option value="60">60</option>
                  </select>
                  <i className="icon-caret-down"></i>
                </div>
              </div>
            </div>
            {totalEvents !== 'loading' && (
              <div className="pagination__current-results">
                {pagerIndex === 0
                  ? `Showing ${paginatedItemCount} of ${totalEvents} Results`
                  : pagerIndex === totalPages - 1
                  ? `Showing ${totalEvents} of ${totalEvents} Results`
                  : `Showing ${paginatedItemCount} of ${totalEvents} Results`}
              </div>
            )}
            {totalEvents === 'loading' && (
              <div className="pagination__current-results">
                <div
                  className="loading-container"
                  style={{ padding: 0, textAlign: 'left' }}
                >
                  <div className="loading loading--circle-bounce">
                    <div className="loading__ball"></div>
                    <div className="loading__ball"></div>
                    <div className="loading__ball"></div>
                  </div>
                  <span>Loading More Results</span>
                </div>
              </div>
            )}
          </div>
          <div className="grid__col-lg-4"></div>
        </div>
      </div>
    </section>
  );
}
